const hydroQuery = typeof window === 'object' ?
    new URLSearchParams(window.location.search) : new URLSearchParams();

const hydroRestricted = hydroQuery.get('hydro') === '1' && hydroQuery.get('restricted') === '1';

export {hydroRestricted};
